import { create } from 'zustand';

/**
 * Whether native push is actually delivering, so the web toast can act as a
 * fallback when it isn't. `isPushAvailable()` only tells us the shell exposes
 * the push surface — not that permission was granted or a token issued.
 *   idle     — not yet determined (registration in progress on native)
 *   active   — a token was issued; the OS will deliver push
 *   inactive — no surface / permission denied / registration failed
 */
export type PushStatus = 'idle' | 'active' | 'inactive';

interface PushStatusState {
  status: PushStatus;
  setStatus: (status: PushStatus) => void;
}

export const usePushStatus = create<PushStatusState>((set) => ({
  status: 'idle',
  setStatus: (status) => set({ status }),
}));
